import api from "./api";

/**
 * Kasa & Finans uçları (backend: /api/finance). Yanıtlar ApiResponse zarfında
 * (res.data.data). Tüm uçlar MANAGER'a özeldir; kendi salonuna kapsanır.
 */
export const financeService = {
  // Kasa (günlük)
  daily: (date) => api.get("/finance/daily", { params: { date } }),
  openDay: (payload) => api.post("/finance/daily/open", payload),
  closeDay: (date) => api.post("/finance/daily/close", null, { params: { date } }),
  monthly: (month) => api.get("/finance/monthly", { params: { month } }),
  createTransaction: (payload) => api.post("/finance/transactions", payload),
  deleteTransaction: (id) => api.delete(`/finance/transactions/${id}`),
  approveTransaction: (id, paymentMethod) =>
    api.post(`/finance/transactions/${id}/approve`, null, { params: { paymentMethod } }),

  // Randevu tahsilatı / alacaklar
  paymentStatus: (appointmentId) => api.get(`/finance/appointments/${appointmentId}/payment`),
  checkout: (appointmentId) => api.get(`/finance/appointments/${appointmentId}/checkout`),
  collectPayment: (appointmentId, payload) =>
    api.post(`/finance/appointments/${appointmentId}/payment`, payload),
  receivables: (from, to) => api.get("/finance/receivables", { params: { from, to } }),

  // Finans (dönemsel)
  summary: (from, to) => api.get("/finance/summary", { params: { from, to } }),
};
